import React, { useCallback, useEffect, useState } from 'react';
import { fabric } from 'fabric';
import { Button, Radio } from 'antd';
import { CollectionServer, deleteInArray, errorCatch, Field, GET, JSXMap, makeFormData, Model, POST, POSTFormData, QueryOrder, updateInArray, useAuth, useNavigation, useUserContext, ycStorage } from 'fennec-ui';
import Icofont from 'react-icofont';
import './index.css';
import Color from '../Color';
import { ycBucket } from '../../../common/Tool';
import { AvatarTextKindContext, useAvatarTextKindContext, useEventContext } from '../../../common/Context';
import { useLocation } from 'react-router';

var FontFaceObserver = require('fontfaceobserver');


function Editor(props) {
    const { avatarTextKind, template, viewWidth, saveWidth, aspectRatioID, multiplier } = props;
    const auth = useAuth();
    const user = useUserContext();
    const [event, setEvent] = useEventContext();

    const textX = -400;//70 * 3;
    const textY = 200;//275 * 3;
    const textFontSize = 50;

    const textX2 = -290;
    const textY2 = 270;
    const textFontSize2 = 50;

    const textX3 = -180;
    const textY3 = 340;
    const textFontSize3 = 50;

    const objectDefault = {
        visibleLastname: false,
        visibleFirstname: false,
        visibleKind: false,
        // lastname: true,
        // firstname: true,
        // kind: true,
        lastnameColor: "white",
        firstnameColor: "white",
        kindColor: "white",
        firstnameX: textX,
        firstnameY: textY,
        firstnameFontSize: textFontSize,
        lastnameX: textX2,
        lastnameY: textY2,
        lastnameFontSize: textFontSize2,
        kindX: textX3,
        kindY: textY3,
        kindFontSize: textFontSize3,
        lastnameText: user.lastname,
        firstnameText: user.firstname,
        angle: 0,
    };
    const [object, setObject] = useState(objectDefault);

    const [canvas, setCanvas] = useState();
    const [image, setImage] = useState();
    const [kind, setKind] = useState();
    const [lastname, setLastname] = useState();
    const [firstname, setFirstname] = useState();
    const [fontLoad, setFontLoad] = useState(false);
    const [avatarTextSettings, setAvatarTextSettings] = useState();

    const canvasWidth = saveWidth;
    const canvasHeight = canvasWidth * multiplier;

    useEffect(() => {
        let canvas = new fabric.Canvas('canvas', {
            height: canvasHeight,
            width: canvasWidth,
            backgroundColor: 'white',
            alignSelf: "center",
        });

        canvas.lowerCanvasEl.style.width = `${viewWidth}px`;
        canvas.lowerCanvasEl.style.height = `${viewWidth * multiplier}px`;
        canvas.upperCanvasEl.style.width = `${viewWidth}px`;
        canvas.upperCanvasEl.style.height = `${viewWidth * multiplier}px`;
        canvas.wrapperEl.style.width = `${viewWidth}px`;
        canvas.wrapperEl.style.height = `${viewWidth * multiplier}px`;

        canvas.allowTaint = true;
        // canvas.foreignObjectRendering = true;
        // canvas.preserveObjectStacking = true;
        setCanvas(canvas);

        var myfont = new FontFaceObserver('UkrainianCompact')
        myfont.load().then(function () {
            setFontLoad(true)
        })
    }, []);

    useEffect(() => {
        if (avatarTextKind) {
            setObject(o => ({
                ...o,
                image: (template) ? ycStorage(auth) + ycBucket(auth) + "/" + template?.ssilka : undefined,
                kindText: (avatarTextKind.length) ? avatarTextKind[0].ID : undefined
            }));
            if (template) {
                GET(auth, `/api/avatar-text-settings/list/${template?.ID}`,
                    ({ data }) => {
                        setAvatarTextSettings(data);
                        if (data && data.length) {
                            let ofirstname = data?.find(e => e.name === "firstname");
                            let olastname = data?.find(e => e.name === "lastname");
                            let okind = data?.find(e => e.name === "kind");
                            setObject(o => ({
                                ...o,
                                visibleFirstname: (ofirstname) ? ofirstname.visible : o.visibleFirstname,
                                firstnameX: (ofirstname) ? ofirstname.x : o.firstnameX,
                                firstnameY: (ofirstname) ? ofirstname.y : o.firstnameY,
                                firstnameFontSize: (ofirstname) ? ofirstname.fontSize : o.firstnameFontSize,
                                firstnameColor: (ofirstname) ? ofirstname.color : o.firstnameColor,
                                visibleLastname: (olastname) ? olastname.visible : o.visibleLastname,
                                lastnameX: (olastname) ? olastname.x : o.lastnameX,
                                lastnameY: (olastname) ? olastname.y : o.lastnameY,
                                lastnameFontSize: (olastname) ? olastname.fontSize : o.lastnameFontSize,
                                lastnameColor: (olastname) ? olastname.color : o.lastnameColor,
                                visibleKind: (okind) ? okind.visible : o.visibleKind,
                                kindX: (okind) ? okind.x : o.kindX,
                                kindY: (okind) ? okind.y : o.kindY,
                                kindFontSize: (okind) ? okind.fontSize : o.kindFontSize,
                                kindColor: (okind) ? okind.color : o.kindColor,
                            }));
                        }
                    }, errorCatch)
            }
        }
    }, [template, avatarTextKind]);
    useEffect(() => {
        if (object.image) {
            fabric.Image.fromURL(object.image, function (img) {
                const properties = img.set({
                    left: 0,
                    top: 0
                });
                if (canvasWidth < canvasHeight) {
                    properties.scaleToWidth(canvasWidth, false);
                } else {
                    properties.scaleToHeight(canvasHeight, false);
                }
                properties.set('selectable', false);
                properties.hasBorders = false;
                properties.hasControls = false;
                setImage(img);
            }, { crossOrigin: 'Anonymous' });
        } else {
            setImage(undefined);
        }
    }, [object.image]);
    useEffect(() => {
        let x = textX;
        let y = textY;
        const properties = new fabric.Text(object.firstnameText || "", { left: x, top: y, fontSize: textFontSize, fontFamily: 'UkrainianCompact', fill: 'white', });
        properties.set('selectable', false);
        properties.hasBorders = false;
        properties.hasControls = false;
        setFirstname(properties);
    }, []);
    useEffect(() => {
        let x = textX;
        let y = textY;
        const properties = new fabric.Text(object.lastnameText || "", { left: x, top: y, fontSize: textFontSize, fontFamily: 'UkrainianCompact', fill: 'white', });
        properties.set('selectable', false);
        properties.hasBorders = false;
        properties.hasControls = false;
        setLastname(properties);
    }, []);
    useEffect(() => {
        let x = textX;
        let y = textY;
        const properties = new fabric.Text("Организатор", { left: x, top: y, fontSize: textFontSize, fontFamily: 'UkrainianCompact', fill: 'white', });
        properties.set('selectable', false);
        properties.hasBorders = false;
        properties.hasControls = false;
        setKind(properties);
    }, []);
    useEffect(() => {
        if (canvas && object) {
            canvas.clear();

            firstname.set("fill", object.firstnameColor);
            lastname.set("fill", object.lastnameColor);
            kind.set("fill", object.kindColor);

            firstname.set("left", object.firstnameX);
            firstname.set("top", object.firstnameY);
            firstname.set("fontSize", object.firstnameFontSize);

            lastname.set("left", object.lastnameX);
            lastname.set("top", object.lastnameY);
            lastname.set("fontSize", object.lastnameFontSize);

            kind.set("left", object.kindX);
            kind.set("top", object.kindY);
            kind.set("fontSize", object.kindFontSize);

            // firstname.text = "!!!!!!!!!!";

            firstname.visible = object.visibleFirstname;
            lastname.visible = object.visibleLastname;
            kind.visible = object.visibleKind;

            let t = (!avatarTextKind) ? "" : avatarTextKind?.find(e => e.ID === object.kindText)?.name;
            kind.text = (t) ? "" + t : "";

            if (image && firstname && lastname && kind) {
                var group = new fabric.Group([image], {
                    left: 0,
                    top: 0,
                });
                canvas.setOverlayImage(group);
                group.add(firstname)
                group.add(lastname)
                group.add(kind)
            }
        }
    }, [canvas, object, image, firstname, lastname, kind, fontLoad]);
    
    const saveImage = useCallback((file, callback) => {
        if (template) {
            POSTFormData(auth, `/api/avatar-template/update`, makeFormData({
                file,
                aspectRatio: aspectRatioID,
                ID: template.ID
            }), callback, errorCatch);
        } else {
            POSTFormData(auth, `/api/avatar-template/new`, makeFormData({
                file,
                aspectRatio: aspectRatioID,
                meropriyatieID: event.ID
            }), callback, errorCatch);
        }
    }, [template])
    const saveTextSettings = useCallback((name, x, y, fontSize, color, fontFamily, visible) => {
        if (template && avatarTextSettings) {
            let o = avatarTextSettings?.find(e => e.name === name);
            if (!o) {
                POST(auth, `/api/avatar-text-settings/new`, {
                    avatarID: template.ID,
                    name,
                    x,
                    y,
                    fontSize,
                    color,
                    fontFamily,
                    visible
                }, ({ data }) => setAvatarTextSettings(o => updateInArray(o, data)), errorCatch);
            } else {
                POST(auth, `/api/avatar-text-settings/update`, {
                    ...o,
                    avatarID: template.ID,
                    name,
                    x,
                    y,
                    fontSize,
                    color,
                    fontFamily,
                    visible
                }, ({ data }) => setAvatarTextSettings(o => updateInArray(o, data)), errorCatch);
            }
        }
    }, [template, avatarTextSettings])
    const load = (files) => {
        let url = files[0];
        saveImage(files, ({ data }) => {
            setObject(o => ({ ...o, image: ycStorage(auth) + ycBucket(auth) + "/" + data.ssilka }));
            if (setEvent) {
                setEvent({ ...event, avatarTemplateMeropriyatie: updateInArray(event.avatarTemplateMeropriyatie, data) })
            }
        });
    };

    return (<div>
        <div style={{ display: "flex", alignItems: "flex-start", flexWrap: "wrap" }}>
            <div style={{ paddingBottom: "10px" }}>
                <Field
                    key={"image"}
                    auth={auth}
                    item={{
                        label: "Фото",
                        name: "file",
                        type: "file",
                        showUploadList: false,
                        accept: ".png",
                        trigger: () => (
                            <div style={{ backgroundColor: "rgb(250, 250, 250)" }}>
                                <canvas id="canvas" />
                            </div>
                        )
                    }}
                    value={(event && template) ? template.ssilka : undefined}
                    onChange={files => {
                        if (files && files.length) {
                            load(files);
                        }
                    }}
                />
            </div>
            <div style={{ padding: "0px 15px", flex: "1" }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <div style={{ width: "100%", padding: "5px 10px", marginBottom: "5px", backgroundColor: "rgb(250 250 250)", borderRadius: "4px" }}>
                        <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                            <div style={{ flex: "1" }}>
                                <Field
                                    key={"visibleFirstname"}
                                    auth={auth}
                                    item={{
                                        label: object.firstnameText,
                                        name: "visibleFirstname",
                                        type: "bool",
                                    }}
                                    value={object.visibleFirstname}
                                    onChange={v => {
                                        setObject(o => ({ ...o, visibleFirstname: v }));
                                        saveTextSettings("firstname", object.firstnameX, object.firstnameY, object.firstnameFontSize, object?.firstnameColor?object?.firstnameColor:objectDefault?.firstnameColor, "UkrainianCompact", v);
                                    }}
                                />
                            </div>
                            <div style={{ flex: "0" }}>
                                <Color
                                    disabled={!object.visibleFirstname}
                                    value={object.firstnameColor}
                                    onChange={v => {
                                        setObject(o => ({ ...o, firstnameColor: v }));
                                        saveTextSettings("firstname", object.firstnameX, object.firstnameY, object.firstnameFontSize, v, "UkrainianCompact", object.visibleFirstname);
                                    }}
                                />
                            </div>
                        </div>
                        <div style={{ width: "100%" }}>
                            <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                <div style={{ flex: "0" }}>
                                    <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => {
                                        setObject(o => ({ ...o, firstnameX: textX }));
                                        saveTextSettings("firstname", textX, object.firstnameY, object.firstnameFontSize, object.firstnameColor, "UkrainianCompact", object.visibleFirstname);
                                    }}>
                                        X:
                                    </Button>
                                </div>
                                <div style={{ flex: "1" }}>
                                    <Field
                                        key={"firstnameX"}
                                        auth={auth}
                                        item={{
                                            label: 'X',
                                            name: "firstnameX",
                                            type: "int",
                                            filterType: "slider",
                                            realtime: true,
                                            min: -1000,
                                            max: 1000,
                                            view: {
                                                disabled: !object.visibleFirstname,
                                            }
                                        }}
                                        value={object.firstnameX}
                                        onChange={v => setObject(o => ({ ...o, firstnameX: v }))}
                                        onAfterChange={v => {
                                            saveTextSettings("firstname", v, object.firstnameY, object.firstnameFontSize, object.firstnameColor, "UkrainianCompact", object.visibleFirstname);
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                <div style={{ flex: "0" }}>
                                    <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => {
                                        setObject(o => ({ ...o, firstnameY: textY }));
                                        saveTextSettings("firstname", object.firstnameX, textY, object.firstnameFontSize, object.firstnameColor, "UkrainianCompact", object.visibleFirstname);
                                    }}>
                                        Y:
                                    </Button>
                                </div>
                                <div style={{ flex: "1" }}>
                                    <Field
                                        key={"firstnameY"}
                                        auth={auth}
                                        item={{
                                            label: 'Y',
                                            name: "firstnameY",
                                            type: "int",
                                            filterType: "slider",
                                            realtime: true,
                                            min: -1000,
                                            max: 1000,
                                            view: {
                                                disabled: !object.visibleFirstname,
                                            }
                                        }}
                                        value={object.firstnameY}
                                        onChange={v => setObject(o => ({ ...o, firstnameY: v }))}
                                        onAfterChange={v => {
                                            saveTextSettings("firstname", object.firstnameX, v, object.firstnameFontSize, object.firstnameColor, "UkrainianCompact", object.visibleFirstname);
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                <div style={{ flex: "0" }}>
                                    <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => {
                                        setObject(o => ({ ...o, firstnameFontSize: textFontSize }));
                                        saveTextSettings("firstname", object.firstnameX, object.firstnameY, textFontSize, object.firstnameColor, "UkrainianCompact", object.visibleFirstname);
                                    }}>
                                        <Icofont icon="font" />
                                    </Button>
                                </div>
                                <div style={{ flex: "1" }}>
                                    <Field
                                        key={"firstnameFontSize"}
                                        auth={auth}
                                        item={{
                                            label: 'Y',
                                            name: "firstnameFontSize",
                                            type: "int",
                                            filterType: "slider",
                                            realtime: true,
                                            min: 22 * 2,
                                            max: 22 * 6,
                                            view: {
                                                disabled: !object.visibleFirstname,
                                            }
                                        }}
                                        value={object.firstnameFontSize}
                                        onChange={v => setObject(o => ({ ...o, firstnameFontSize: v }))}
                                        onAfterChange={v => {
                                            saveTextSettings("firstname", object.firstnameX, object.firstnameY, v, object.firstnameColor, "UkrainianCompact", object.visibleFirstname);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ width: "100%", padding: "5px 10px", marginBottom: "5px", backgroundColor: "rgb(250 250 250)", borderRadius: "4px" }}>
                        <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                            <div style={{ flex: "1" }}>
                                <Field
                                    key={"visibleLastname"}
                                    auth={auth}
                                    item={{
                                        label: object.lastnameText,
                                        name: "visibleLastname",
                                        type: "bool",
                                    }}
                                    value={object.visibleLastname}
                                    onChange={v => {
                                        setObject(o => ({ ...o, visibleLastname: v }));
                                        saveTextSettings("lastname", object.lastnameX, object.lastnameY, object.lastnameFontSize, object?.lastnameColor?object?.lastnameColor:objectDefault?.lastnameColor, "UkrainianCompact", v);
                                    }}
                                />
                            </div>
                            <div style={{ flex: "0" }}>
                                <Color
                                    disabled={!object.visibleLastname}
                                    value={object.lastnameColor}
                                    onChange={v => {
                                        setObject(o => ({ ...o, lastnameColor: v }));
                                        saveTextSettings("lastname", object.lastnameX, object.lastnameY, object.lastnameFontSize, v, "UkrainianCompact", object.visibleLastname);
                                    }}
                                />
                            </div>
                        </div>
                        <div style={{ width: "100%" }}>
                            <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                <div style={{ flex: "0" }}>
                                    <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => {
                                        setObject(o => ({ ...o, lastnameX: textX2 }));
                                        saveTextSettings("lastname", textX2, object.lastnameY, object.lastnameFontSize, object.lastnameColor, "UkrainianCompact", object.visibleLastname);
                                    }}>
                                        X:
                                    </Button>
                                </div>
                                <div style={{ flex: "1" }}>
                                    <Field
                                        key={"lastnameX"}
                                        auth={auth}
                                        item={{
                                            label: 'X',
                                            name: "lastnameX",
                                            type: "int",
                                            filterType: "slider",
                                            realtime: true,
                                            min: -1000,
                                            max: 1000,
                                            view: {
                                                disabled: !object.visibleLastname,
                                            }
                                        }}
                                        value={object.lastnameX}
                                        onChange={v => setObject(o => ({ ...o, lastnameX: v }))}
                                        onAfterChange={v => {
                                            saveTextSettings("lastname", v, object.lastnameY, object.lastnameFontSize, object.lastnameColor, "UkrainianCompact", object.visibleLastname)
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                <div style={{ flex: "0" }}>
                                    <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => {
                                        setObject(o => ({ ...o, lastnameY: textY2 }));
                                        saveTextSettings("lastname", object.lastnameX, textY2, object.lastnameFontSize, object.lastnameColor, "UkrainianCompact", object.visibleLastname);
                                    }}>
                                        Y:
                                    </Button>
                                </div>
                                <div style={{ flex: "1" }}>
                                    <Field
                                        key={"lastnameY"}
                                        auth={auth}
                                        item={{
                                            label: 'Y',
                                            name: "lastnameY",
                                            type: "int",
                                            filterType: "slider",
                                            realtime: true,
                                            min: -1000,
                                            max: 1000,
                                            view: {
                                                disabled: !object.visibleLastname,
                                            }
                                        }}
                                        value={object.lastnameY}
                                        onChange={v => setObject(o => ({ ...o, lastnameY: v }))}
                                        onAfterChange={v => {
                                            saveTextSettings("lastname", object.lastnameX, v, object.lastnameFontSize, object.lastnameColor, "UkrainianCompact", object.visibleLastname)
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                <div style={{ flex: "0" }}>
                                    <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => {
                                        setObject(o => ({ ...o, lastnameFontSize: textFontSize2 }));
                                        saveTextSettings("lastname", object.lastnameX, object.lastnameY, textFontSize2, object.lastnameColor, "UkrainianCompact", object.visibleLastname);
                                    }}>
                                        <Icofont icon="font" />
                                    </Button>
                                </div>
                                <div style={{ flex: "1" }}>
                                    <Field
                                        key={"lastnameFontSize"}
                                        auth={auth}
                                        item={{
                                            label: 'Y',
                                            name: "lastnameFontSize",
                                            type: "int",
                                            filterType: "slider",
                                            realtime: true,
                                            min: 22 * 2,
                                            max: 22 * 6,
                                            view: {
                                                disabled: !object.visibleLastname,
                                            }
                                        }}
                                        value={object.lastnameFontSize}
                                        onChange={v => setObject(o => ({ ...o, lastnameFontSize: v }))}
                                        onAfterChange={v => {
                                            saveTextSettings("lastname", object.lastnameX, object.lastnameY, v, object.lastnameColor, "UkrainianCompact", object.visibleLastname)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ width: "100%", padding: "5px 10px", marginBottom: "5px", backgroundColor: "rgb(250 250 250)", borderRadius: "4px" }}>
                        <div style={{ width: "100%", display: "flex", gap: "7px" }}>
                            <Field
                                key={"visibleKind"}
                                auth={auth}
                                item={{
                                    // label: 'Организатор',
                                    name: "visibleKind",
                                    type: "bool",
                                }}
                                value={object.visibleKind}
                                onChange={v => {
                                    setObject(o => ({ ...o, visibleKind: v }));
                                    saveTextSettings("kind", object.kindX, object.kindY, object.kindFontSize, object?.kindColor?object?.kindColor:objectDefault?.kindColor, "UkrainianCompact", v);
                                }}
                            />
                            <Field
                                key={"kindText"}
                                auth={auth}
                                item={{
                                    // label: 'Организатор',
                                    name: "kindText",
                                    type: "object",
                                    view: {
                                        disabled: !object.visibleKind,
                                    },
                                    relation: {
                                        display: (item) => {
                                            return item.name
                                        },
                                        reference: {
                                            data: avatarTextKind,
                                        }
                                    },
                                    size: "small"
                                }}
                                value={object.kindText}
                                onChange={v => setObject(o => ({ ...o, kindText: v }))}
                            />
                            <div style={{ flex: "0" }}>
                                <Color
                                    value={object.kindColor}
                                    onChange={v => {
                                        setObject(o => ({ ...o, kindColor: v }));
                                        saveTextSettings("kind", object.kindX, object.kindY, object.kindFontSize, v, "UkrainianCompact", object.visibleKind)
                                    }}
                                />
                            </div>
                        </div>
                        <div style={{ width: "100%" }}>
                            <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                <div style={{ flex: "0" }}>
                                    <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => {
                                        setObject(o => ({ ...o, kindX: textX3 }));
                                        saveTextSettings("kind", textX3, object.kindY, object.kindFontSize, object.kindColor, "UkrainianCompact", object.visibleKind);
                                    }}>
                                        X:
                                    </Button>
                                </div>
                                <div style={{ flex: "1" }}>
                                    <Field
                                        key={"kindX"}
                                        auth={auth}
                                        item={{
                                            label: 'X',
                                            name: "kindX",
                                            type: "int",
                                            filterType: "slider",
                                            realtime: true,
                                            min: -1000,
                                            max: 1000,
                                            view: {
                                                disabled: !object.visibleKind,
                                            }
                                        }}
                                        value={object.kindX}
                                        onChange={v => setObject(o => ({ ...o, kindX: v }))}
                                        onAfterChange={v => {
                                            saveTextSettings("kind", v, object.kindY, object.kindFontSize, object.kindColor, "UkrainianCompact", object.visibleKind)
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                <div style={{ flex: "0" }}>
                                    <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => {
                                        setObject(o => ({ ...o, kindY: textY3 }));
                                        saveTextSettings("kind", object.kindX, textY3, object.kindFontSize, object.kindColor, "UkrainianCompact", object.visibleKind)
                                    }}>
                                        Y:
                                    </Button>
                                </div>
                                <div style={{ flex: "1" }}>
                                    <Field
                                        key={"kindY"}
                                        auth={auth}
                                        item={{
                                            label: 'Y',
                                            name: "kindY",
                                            type: "int",
                                            filterType: "slider",
                                            realtime: true,
                                            min: -1000,
                                            max: 1000,
                                            view: {
                                                disabled: !object.visibleKind,
                                            }
                                        }}
                                        value={object.kindY}
                                        onChange={v => setObject(o => ({ ...o, kindY: v }))}
                                        onAfterChange={v => {
                                            saveTextSettings("kind", object.kindX, v, object.kindFontSize, object.kindColor, "UkrainianCompact", object.visibleKind)
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                <div style={{ flex: "0" }}>
                                    <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => {
                                        setObject(o => ({ ...o, kindFontSize: textFontSize3 }));
                                        saveTextSettings("kind", object.kindX, object.kindY, textFontSize3, object.kindColor, "UkrainianCompact", object.visibleKind);
                                    }}>
                                        <Icofont icon="font" />
                                    </Button>
                                </div>
                                <div style={{ flex: "1" }}>
                                    <Field
                                        key={"kindFontSize"}
                                        auth={auth}
                                        item={{
                                            label: 'Y',
                                            name: "kindFontSize",
                                            type: "int",
                                            filterType: "slider",
                                            realtime: true,
                                            min: 22 * 2,
                                            max: 22 * 6,
                                            view: {
                                                disabled: !object.visibleKind,
                                            }
                                        }}
                                        value={object.kindFontSize}
                                        onChange={v => setObject(o => ({ ...o, kindFontSize: v }))}
                                        onAfterChange={v => {
                                            saveTextSettings("kind", object.kindX, object.kindY, v, object.kindColor, "UkrainianCompact", object.visibleKind)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>)
}
export default function AvatarAdmin(props) {
    const navigation = useNavigation();
    const { pathname } = useLocation();
    const [event, setEvent] = useEventContext();
    const auth = useAuth();
    const user = useUserContext();
    const [avatarTextKind, setAvatarTextKind] = useState([]);

    // Аватарки
    // 2269x2269 | 1:1  | 1:1  
    // 2269x4033 | 9:16 | 1.7777 : 0.5626
    // 1591x531  | 3:1  | 2,996233522 : 0,333752357
    const aspectRatioArray = [
        { ID: 1, key: "1:1", label: "Квадрат", multiplier: 1 / 1, divider: 1 / 1 },
        { ID: 2, key: "9:16", label: "INSTAGRAM", multiplier: 16 / 9, divider: 9 / 16 },
        { ID: 3, key: "3:1", label: "VK", multiplier: 1 / 3, divider: 3 / 1 },
        { ID: 4, key: "3:4", label: "3:4", multiplier: 4 / 3, divider: 3 / 4 },
    ]
    const [aspectRatio, setAspectRatio] = useState(aspectRatioArray[0]);
    const getAvatarTemplateByAspectRatio = (avatarTemplates, aspectRatio) => {
        return avatarTemplates?.find(e => (e.aspectRatio === aspectRatio.ID) || (!e.aspectRatio && aspectRatio.ID === 1));
    }
    const [template, setTemplate] = useState();

    useEffect(() => {
        if (event && event.avatarTemplateMeropriyatie && event.avatarTemplateMeropriyatie.length) {
            let avatarTemplate = getAvatarTemplateByAspectRatio(event.avatarTemplateMeropriyatie, aspectRatio);
            setTemplate(avatarTemplate)
        }
    }, [event, aspectRatio]);
    useEffect(() => {
        if (template) {
            GET(auth, `/api/avatar-text/list/${template?.ID}`,
                ({ data }) => {
                    setAvatarTextKind(data);
                }, errorCatch)
        }
    }, [template])
    const deleteTemplate = useCallback(() => {
        if (template) {
            GET(auth, `/api/avatar-template/delete/${template?.ID}`, () => {
                setEvent({...event, avatarTemplateMeropriyatie: deleteInArray(event?.avatarTemplateMeropriyatie, template)})
            }, errorCatch);
        }
    }, [event, template])
    return (
        <div style={{ paddingBottom: "25px", backgroundColor: "white" }}>
            {event &&
                <div style={{ display: "flex", justifyContent: "space-between", gap: "15px", alignItems: "center" }}>
                    <div style={{ fontWeight: "600", padding: "10px 0", fontSize: "20px", flex: "1" }}>
                        {event.nazvanieMeropriyatiya}
                    </div>
                    <div style={{ flex: "0" }}>
                        <Button size='small' type="link" onClick={() => {
                            if (pathname.slice(0, -8).endsWith('avatar')) {
                                navigation(pathname.slice(0, -8))
                            } else if (pathname.slice(0, -9).endsWith('avatar')) {
                                navigation(pathname.slice(0, -9))
                            }
                        }}>Аватарка "по-быстрому"</Button>
                    </div>
                </div>
            }
            <div style={{ width: "100%", padding: "5px 0px", marginBottom: "5px", backgroundColor: "rgb(250 250 250)", borderRadius: "4px", display:"flex", justifyContent:"space-between" }}>
                <Radio.Group value={aspectRatio?.ID} onChange={(e) => setAspectRatio(aspectRatioArray.find(c => c?.ID == parseInt(e.target.value)))}>
                    {JSXMap(aspectRatioArray, (e, idx) => (<Radio.Button key={idx} value={e.ID} style={(getAvatarTemplateByAspectRatio(event.avatarTemplateMeropriyatie, e))?{backgroundColor:"#cfebff"}:{}} >{e.key}</Radio.Button>))}
                </Radio.Group>
                <Button danger onClick={deleteTemplate}>Удалить</Button> 
            </div>
            {aspectRatio && <Editor key={aspectRatio?.ID} template={template} avatarTextKind={avatarTextKind} viewWidth={(aspectRatio.ID != 3) ? 400 : 920} saveWidth={(aspectRatio.ID != 3) ? 1200 : 2000} aspectRatioID={aspectRatio?.ID} multiplier={aspectRatio?.multiplier}/>}
            {(event && template) &&
                <div style={{ display: "flex", flexDirection: "column", paddingTop: "25px" }}>
                    <div style={{ width: "100%", padding: "7px 10px", marginBottom: "5px", backgroundColor: "rgb(250 250 250)", borderRadius: "4px" }}>
                        <CollectionServer
                            auth={auth}
                            name={"AvatarText"}
                            source={`/api/avatar-text/page/${template?.ID}`}
                            contextFilters={() => [
                                QueryOrder("isAdmin", "DESC")
                            ]}
                            filters={() => []}
                            size={"small"}
                            mode={"list"}
                            render={(e, idx, options) => {
                                return (
                                    <div key={idx} style={{ padding: "10px", width: "100%", borderTop: (idx > 0) ? "1px solid #eee" : "none" }}>
                                        <div style={{ display: "flex" }}>
                                            <div style={{ width: "25px" }}>
                                                {e.isAdmin == true && <div><Icofont icon="badge" style={{ color: "blue" }} /></div>}
                                            </div>
                                            <div>{e.name}</div>
                                        </div>
                                    </div>
                                )
                            }}
                            collectionActions={() => [{
                                auth: auth,
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    POST(auth, `/api/avatar-text/new`, { ...values, avatarID: template?.ID },
                                        ({ data }) => {
                                            setCollection(updateInArray(collection, data));
                                            setAvatarTextKind(o => updateInArray(o, data));
                                            close();
                                        }, (err) => errorCatch(err, unlock)
                                    );
                                },
                                title: "Добавить текст",
                                form: Model,
                                meta: [
                                    {
                                        label: "Текст",
                                        name: "name",
                                        type: "string",
                                    },
                                    {
                                        label: "Для админа",
                                        name: "isAdmin",
                                        type: "bool",
                                    },
                                ],
                            }]}
                            modelActions={(item) => [
                                {
                                    auth: auth,
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        POST(auth, `/api/avatar-text/update`, { ...values, ID: item.ID },
                                            ({ data }) => {
                                                setCollection(updateInArray(collection, data));
                                                setAvatarTextKind(o => updateInArray(o, data));
                                                close();
                                            }, (err) => errorCatch(err, unlock)
                                        );
                                    },
                                    title: "Изменить",
                                    options: {
                                        initialValues: item,
                                    },
                                    form: Model,
                                    meta: [
                                        {
                                            label: "Текст",
                                            name: "name",
                                            type: "string",
                                        },
                                        {
                                            label: "Для админа",
                                            name: "isAdmin",
                                            type: "bool",
                                        },
                                    ],
                                },
                                {
                                    title: <span style={{ color: "red" }}>Удалить</span>,
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        GET(auth, `/api/avatar-text/delete/${item.ID}`,
                                            () => setCollection(deleteInArray(collection, item)), errorCatch
                                        );
                                    },
                                }
                            ]}
                        />
                    </div>
                </div>
            }
        </div>
    );
}
